<template>
    <li :class="`${isDropdownOpen ? 'active': ''} sidebar-dropdown-item w-full`" >
            <div :title="dropDownTitle" @click="toggleDropdownMenu" class="sidebar-list-item sidebar-dropdown-header w-full flex justify-between items-center gap-3 py-3 px-3">
                <div class="flex items-center gap-4">
                    <slot name="top-icon"/>
                    <span class="hide-if-close">{{ dropDownTitle }}</span>   
                </div>
                <svg :style="{ transform: isDropdownOpen ? 'rotate(180deg)': 'rotate(90deg)' }" xmlns="http://www.w3.org/2000/svg" class="dropdown-arrow text-gray-400 hide-if-close" width="17" height="17" viewBox="0 0 24 24"><path fill="currentColor" d="m12 10.828l-4.95 4.95l-1.414-1.414L12 8l6.364 6.364l-1.415 1.414l-4.95-4.95Z"/></svg>
            </div>
          <div>
            <transition name="dropdown" mode="in-out">
                <div v-if="isDropdownOpen" @click="() => isDropdownOpen = true" class="dropdown-menu">
                    <slot />
                </div>
            </transition>
          </div>
    </li>
</template>

<script>
export default {
    data(){
        return{
            isDropdownOpen: false
        }
    },
    props: {
        dropDownTitle: String,
        mainRoute: {
            type: String,
            default: "",
            required: true
        },
        currentOpendedDropdown: {
            type: String,
            default: "",
        },
        changeCurrentOpendedDropdown: {
            type: Function,
        }
    },
    methods: {
        toggleDropdownMenu(){
            this.isDropdownOpen = !this.isDropdownOpen;
        }
    },
    computed:{
        isOpen(){
            return this.mainRoute ? this.$route?.path?.includes(this.mainRoute) : false;
        }
    },
    watch: {
        isOpen: {
            immediate: true,
            handler(val){
                if(typeof val === "boolean"){
                    this.isDropdownOpen = this.isOpen;
                }
            }
        }
    }
}
</script>

<style scoped>
    .dropdown-arrow{
        width: 18;
        height: 18;
        transition: transform .25s cubic-bezier(.25,.8,.5,1), color 0.25s linear;
    }
    .sidebar-dropdown-item .sidebar-dropdown-header:hover .dropdown-arrow{
        color: #fff;
    }
    .sidebar-dropdown-item.active{
        background: rgba(0,0,0,.3);
    }
    .dropdown-menu{
        overflow: hidden;
        transition: height 0.3s linear;
    }
</style>